module.exports = __webpack_public_path__ + "media/i-love-you-3000.27a747da.mp3";